/**
 * OGPImage: Open Graph Image
 * A component used for setting up the default Open Graph image in non-xpa pages.
 **/

export function OGImage(): JSX.Element {
  return (
    <>
      <meta
        property="og:image"
        content="https://peregrine.onefootball.com/images/sharing_banner.png"
      />
    </>
  );
}
